import React from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import ButtonBase from "@material-ui/core/ButtonBase";
import { useInvCa } from "../../../St/Reviews/UseStyle";
import { sto } from "../../../Context/InshData";
import { QRCodeCanvas } from "qrcode.react";

function FooterCashier(props) {
    const {inv,locInv,found}=props;
  const clas = useInvCa();

  const sty = {
    cntr: { textAlign: "center" },
    lft: { textAlign: "left", padingLeft: 5 },
    rit: { textAlign: "right", padingRight: 5 },
    dirR: { direction: "rtl", color: "black" },
    dirL: { direction: "ltr" },
  };

  return (
    // <span style={{color:'black'}}>
    <Grid item container style={sty.dirR}>
      <Grid item container style={sty.cntr} spacing={0}>
        <br />
        <Grid xs={12}>
          <Typography
            className={[clas.contntSub]}
            style={{
              margin: "0.5rem 0.1rem 0.5rem 0.1rem",
              borderRadius: 5,
              color: "#5e5e5e",
              background: "#ffffee",
              padding: "0.5rem 0.5rem 0.5rem 0.5rem",
            }}
          >
            {found.Address}
          </Typography>
        </Grid>
        {inv.tax > 0 && (


          <Grid item xs={12}>
            {(locInv?.Step_inv2 && inv?.ZatcaQR) ?
              (
                <ButtonBase style={{ borderRadius: "3", margin: 0, padding: 0, marginTop: 0 }}>
                  {
                    <QRCodeCanvas value={inv?.ZatcaQR} 
                    size={220}
                      level="M"
                      includeMargin={true}
                      style={{ imageRendering: "pixelated" }}/>
                  }

                </ButtonBase>
              ) :
              (
                <ButtonBase
                  style={{
                    border: "solid 0.1px",
                    borderRadius: "3",
                    margin: 0,
                    padding: 0,
                  }}
                >
                  <img
                    src={`data:image/jpeg;base64,${inv.qr_image}`}
                    style={{ height: "57mm", width: "57mm" }}
                    alt={found.nameA}
                  />
                </ButtonBase>
              )
            }


          </Grid>
        )}

        <Grid item xs={12}>
          {"_____"}
        </Grid>
        <Grid item xs={12}>
          {sto?.usernames}
        </Grid>
      </Grid>
    </Grid>
    // </span>
  );
}
export default FooterCashier;


